import alloyAnalytics from '@telus/alloy-analytics'
import { OffersFilterProps, TagProps } from '../../blocks/core/OffersFilter/OffersFilter'

type SysID = OffersFilterProps['sysID']
type EntryTitle = OffersFilterProps['entryTitle']
type Tag = TagProps['label']

type FilterTagProps = { sysID: SysID; entryTitle: EntryTitle; tag: Tag; isNewFilter: boolean }

type SearchProps = {
  searchTerm: string
  numberOfResults: number
  isFirstSearch: boolean
}

const TOOL_TYPE = 'offers_filter'

const alloyEvents = {
  filterTag: ({ sysID, entryTitle, tag, isNewFilter }: FilterTagProps) => {
    const action = isNewFilter ? 'add_filter' : 'remove_filter'
    const toolSubmit = {
      name: `${action}-tag-${tag}`,
      toolName: `offers_filter-${entryTitle}`,
      toolType: TOOL_TYPE,
      toolUsageID: sysID,
      toolSelections: `${action}-tag-${tag}`,
    }
    alloyAnalytics.event('toolSubmit').webInteraction(toolSubmit).fire()
  },
  search: ({ searchTerm, numberOfResults, isFirstSearch }: SearchProps) => {
    const interactionName = numberOfResults === 0 ? 'site-builder-search-no-results' : 'site-builder-search-success'
    alloyAnalytics
      .event('search')
      .search({ term: searchTerm, numberOfResults, isFirstSearch })
      .webInteraction({ name: interactionName })
      .fire()
  },
}

export default alloyEvents
